import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetFlexiReimbursementClaimInput,
  GetFlexiReimbursementClaimResponse,
  GetFlexiReimbursementClaimVariables,
} from '../types';

const getFlexiReimbursementClaimQuery = gql`
  query GetFlexiReimbursementClaim($input: GetFlexiReimbursementClaimInput!) {
    payrollGetFlexiReimbursementClaim(input: $input) {
      code
      success
      message
      claim {
        claim_id
        tenant_id
        merchant_id
        component_id
        assignment_id
        expense_date
        employee_id
        employee_name
        claim_amount
        approved_amount
        claim_description
        claim_evidence_id
        claim_status
        claim_comments
        last_modified_by
        created_at
        updated_at
        component_display_name
        approver_user_name
        approval_rejection_date
      }
    }
  }
`;

export const getFlexiReimbursementClaim = (input: GetFlexiReimbursementClaimInput) => {
  return graphQLApi<GetFlexiReimbursementClaimResponse, GetFlexiReimbursementClaimVariables>({
    query: getFlexiReimbursementClaimQuery,
    queryVariables: { input },
  });
};
